import React from 'react'
import { Alert } from 'reactstrap'
import PropTypes from 'prop-types'

/**
 * View giving the status of the unwind action
 * for UploadCSVBackups.
 * @param {object} props 
 */
function UnwindStatus ({    
  backup,
  status,
  unwindErrors,
  unwindPhase,
  ...props,
}) {
  if (!backup) return null
  const display_errors = unwindErrors.length > 0
  let statusDisplay = status
  if (unwindPhase && unwindPhase !== 'GroupUAs') {
    const num = props[`status${unwindPhase}`]
    const denom = backup[`created${unwindPhase}`].length
    statusDisplay = `${statusDisplay} (${num} / ${denom})`
  }
  return (
    <div>
      {display_errors &&
        <Alert color='danger'>
          <ul>
            {unwindErrors.map((err, n) => <li key={`err${n}`}>{err}</li>)}
          </ul>
        </Alert>
      }
      <Alert color='info'>{statusDisplay}</Alert>
    </div>
  )
}

const { array, number, object, string, } = PropTypes
UnwindStatus.propTypes = {
  backup: object,
  status: string.isRequired,
  statusClasses: number.isRequired,
  statusGroupUAs: number.isRequired,
  statusStudents: number.isRequired,
  statusTeachers: number.isRequired,
  statusUserAssessments: number.isRequired,
  unwindErrors: array.isRequired,
  unwindPhase: string.isRequired,
}
export default UnwindStatus


// WEBPACK FOOTER //
// ./src/components/Assessment/UploadCSVComponents/UnwindStatus.js